import { PopoverBasicHelp } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import InternalLink from "~/components/Navigation/InternalLink/index";
interface RetentionPolicyInfoIconProps {
    spaceId: string;
}
export function RetentionPolicyInfoIcon({ spaceId }: RetentionPolicyInfoIconProps) {
    const retentionLink = (<InternalLink to={links.retentionPoliciesPage.generateUrl({ spaceId })}>
            <span style={{ display: "inline-flex", alignItems: "center", gap: space[4] }}>
                Retention
                <em className="fa-solid fa-external-link" style={{ fontSize: "12px" }}/>
            </span>
        </InternalLink>);
    return (<span style={{ marginLeft: space[8] }} data-testid="retention-policy-info-icon">
            <PopoverBasicHelp placement="bottom-start" title="Default retention policy" description={<span>You can set the default retention policy in the {retentionLink} area.</span>}/>
        </span>);
}
